import { Attributes, DateUtils, Misc, Rules, Validation, ValueObject } from '@singularsystems/neo-core';
import { PaymentType } from '../PaymentType';

export default class NewPaymentExportCommand extends ValueObject {

    constructor() {
        super();
        this.makeObservable();
    }

    @Rules.Required()
    public entityId: number = 0;

    public paymentType: PaymentType | null = null;

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public startDate: Date = DateUtils.add(DateUtils.today(), { months: -1 });

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public endDate: Date = DateUtils.today();

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
      super.addBusinessRules(rules);
    }

    public toString(): string {
      return "New Payment Export Command";
    }
}